import { useTranslation } from "react-i18next";
import { Button, Col, Form, FormInstance, Row, Typography } from "antd";
import { FunctionComponent } from "react";
import FormItemDropdown from "../../../../../../components/form-dropdown/FormItemDropdown";
import { DeleteOutlined, FilterOutlined } from "@ant-design/icons";

type FormFilterProps = {
  onFinish?: any;
  listVersions: any;
  form: FormInstance;
  showFilter?: boolean;
  version: string | null;
  clearFilter: () => void;
};

const FormFilter: FunctionComponent<FormFilterProps> = ({
  form,
  version,
  onFinish,
  showFilter,
  listVersions,
  clearFilter,
}) => {
  const { t } = useTranslation();
  const publishStatusOptions = [
    {
      value: true,
      label: t("Đã xuất bản", "Đã xuất bản")
    },
    {
      value: false,
      label: t("Chưa xuất bản", "Chưa xuất bản")
    },
  ];

  return (
    <>
      <div className={`wrapper-filter ${showFilter ? "open" : ""}`}>
        <Form name="filterForm" onFinish={onFinish} form={form} >
          <Row gutter={[{ xs: 8, xl: 24, md: 16 }, 12]}>
            <Col
              xl={{ span: 6 }}
              md={{ span: 5 }}
              sm={{ span: 5 }}
              xs={{ span: 24 }}
            >
              <Typography.Title level={5}>{t("Phiên bản", "Phiên bản")}</Typography.Title>
              <Form.Item name="version">
                <FormItemDropdown
                  allowClear
                  options={listVersions}
                  modeDropdown="multiple"
                  placeholder={t("Chọn phiên bản", "Chọn phiên bản")}
                />
              </Form.Item>
            </Col>
            <Col
              xl={{ span: 6 }}
              md={{ span: 5 }}
              sm={{ span: 5 }}
              xs={{ span: 24 }}
            >
              <Typography.Title level={5}>{t("Trạng thái xuất bản", "Trạng thái xuất bản")}</Typography.Title>
              <Form.Item name="publishStatus">
                <FormItemDropdown
                  allowClear
                  options={publishStatusOptions}
                  placeholder={t("Chọn trạng thái xuất bản", "Chọn trạng thái xuất bản")}
                />
              </Form.Item>
            </Col>
            <Col
              xl={{ span: 5 }}
              md={{ span: 9 }}
              sm={{ span: 9 }}
              xs={{ span: 24 }}
              className="flex align-end"
            >
              <div className="group-btn--filter">
                <Button
                  className="btn btn-primary filter-btn"
                  htmlType="submit"
                >
                  <FilterOutlined />
                  <Typography.Text>{t("Lọc", "Lọc")}</Typography.Text>
                </Button>
                <Button
                  className="btn btn-outlined clear-filter-btn"
                  onClick={() => clearFilter()}
                >
                  <DeleteOutlined />
                  <Typography.Text>{t("Xóa bộ lọc", "Xóa bộ lọc")}</Typography.Text>
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
};

export default FormFilter;